import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'

import Header from '../header/header'
import './layout.css'
import { boxWrap } from './layout.styles'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Bodega Iniesta Guatemala' },
            { name: 'keywords', content: 'Bodega Iniesta es el reflejo del esfuerzo de una familia por llevar a cabo un proyecto de la tierra, de pura tradición y dedicación. Algo que nos une a nuestros orígenes a través del gusto por los buenos vinos.' },
          ]}
        >
        <html lang="en" />
        </Helmet>
        <div className={`${boxWrap}`}>
          <Header siteTitle={data.site.siteMetadata.title} />
          {children}
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
